export default {
    data() {
        return {
            speedOptions: [
                { text: '33rpm', value: '33' },
                { text: '45rpm', value: '45' },
                { text: '78rpm', value: '78' },
            ]
        }
    }
}